import { Column } from '@react-email/components';

const column = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Column {...attributes} {...element.attributes}>
                {children}
            </Column>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return <Column {...attributes}>{children}</Column>;
    },
};

export default column;
